import React from 'react';
import { View } from 'react-native';

import { Text } from '../../components';
import { useThemedStyles } from '../../hooks/useThemedStyles';
import { createCorrectMarketRestockStyles } from './CorrectMarketRestockView.styles';

const formatVarianceChange = ({ before, change }) => (
	change
		? `Current ${before} · ${change > 0 ? '+' : ''}${change}`
		: `Current ${before} · unchanged`
);

const RestockCorrectionVariance = ({ label, variance }) => {
	const styles = useThemedStyles(createCorrectMarketRestockStyles);

	return (
		<View style={styles.stat}>
			<Text style={styles.fieldLabel}>{label}</Text>
			<Text style={styles.varianceValue}>{variance.after}</Text>
			<Text style={styles.hint}>{formatVarianceChange(variance)}</Text>
		</View>
	);
};

export default RestockCorrectionVariance;
